var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQrCodeScanner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 6.5V9.5H6.5V6.5H9.5ZM11 5H5V11H11V5ZM9.5 14.5V17.5H6.5V14.5H9.5ZM11 13H5V19H11V13ZM17.5 6.5V9.5H14.5V6.5H17.5ZM19 5H13V11H19V5ZM13 13H14.5V14.5H13V13ZM14.5 14.5H16V16H14.5V14.5ZM16 13H17.5V14.5H16V13ZM13 16H14.5V17.5H13V16ZM14.5 17.5H16V19H14.5V17.5ZM16 16H17.5V17.5H16V16ZM17.5 14.5H19V16H17.5V14.5ZM17.5 17.5H19V19H17.5V17.5ZM21 7C20.45 7 20 6.55 20 6V4H18C17.45 4 17 3.55 17 3C17 2.45 17.45 2 18 2H21C21.55 2 22 2.45 22 3V6C22 6.55 21.55 7 21 7ZM22 21V18C22 17.45 21.55 17 21 17C20.45 17 20 17.45 20 18V20H18C17.45 20 17 20.45 17 21C17 21.55 17.45 22 18 22H21C21.55 22 22 21.55 22 21ZM3 22H6C6.55 22 7 21.55 7 21C7 20.45 6.55 20 6 20H4V18C4 17.45 3.55 17 3 17C2.45 17 2 17.45 2 18V21C2 21.55 2.45 22 3 22ZM2 3V6C2 6.55 2.45 7 3 7C3.55 7 4 6.55 4 6V4H6C6.55 4 7 3.55 7 3C7 2.45 6.55 2 6 2H3C2.45 2 2 2.45 2 3Z",
    fill: "#2541B2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCodeScanner);
export default __webpack_public_path__ + "static/media/qr_code_scanner.c6778422beb1def2116e2fc30cd71b0e.svg";
export { ForwardRef as ReactComponent };